import { useSidebar } from "../../core/ui/navigation/use_sidebar";
import { NavLink } from "react-router-dom";
import { CoreButton } from "../../core/ui/button/button";
import { NavIcon } from "../../core/ui/navigation/nav_icon";
import { observer } from "mobx-react-lite";
import { authorizationStore as store } from "./authorization_store";

export const SessionControls = observer(() => {
  const { open, setOpen, compact, sidebarRef } = useSidebar();
  return (
    <>
      <header className="session-controls">
        <CoreButton
          className="admin-menu-toggle"
          aria-label="Открыть меню"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <NavIcon name="menu" />
        </CoreButton>
        <NavLink to="/task" className="admin-brand">
          podvaltech
        </NavLink>
        <span className="admin-account">
          <NavIcon name="profile" />
          {store.user?.username}
        </span>
        <CoreButton disabled={store.isLoading} onClick={() => store.logout()}>
          Выйти
        </CoreButton>
        {store.errorMessage && <div role="alert">{store.errorMessage}</div>}
      </header>
      {store.user?.role === "admin" && (
        <>
          {open && (
            <button
              className="admin-sidebar-backdrop"
              aria-label="Закрыть меню"
              onClick={() => setOpen(false)}
            />
          )}
          <aside
            ref={sidebarRef}
            hidden={compact && !open}
            className={`admin-sidebar ${open ? "is-open" : ""}`}
          >
            <NavLink
              className="admin-brand"
              to="/task"
              onClick={() => setOpen(false)}
            >
              podvaltech
            </NavLink>
            <nav className="admin-navigation" aria-label="Разделы админки">
              <NavLink to="/task" onClick={() => setOpen(false)}>
                <NavIcon name="bank" />
                Банк заданий
              </NavLink>
              <NavLink to="/exam" onClick={() => setOpen(false)}>
                <NavIcon name="tests" />
                Тесты и варианты
              </NavLink>
              <NavLink to="/student" onClick={() => setOpen(false)}>
                <NavIcon name="profile" />
                Ученики
              </NavLink>
            </nav>
          </aside>
        </>
      )}
    </>
  );
});

export const AccessDenied = () => (
  <div style={{ padding: 24 }}>
    <p>Админка доступна только администратору.</p>
    <SessionControls />
  </div>
);
